import { computed } from '@vue/composition-api'

export default function useHorseMerge(proxy) {
  const store = proxy.$store
  const searchResults = computed(() => store.getters['horseMerge/searchResults'])
  const searchLoading = computed(() => store.getters['horseMerge/searchLoading'])
  const preview = computed(() => store.getters['horseMerge/preview'])
  const previewLoading = computed(() => store.getters['horseMerge/previewLoading'])
  const merging = computed(() => store.getters['horseMerge/merging'])
  let searchTimer = null

  function search(query, sourceHorseId) {
    clearTimeout(searchTimer)
    searchTimer = setTimeout(() => {
      store.dispatch('horseMerge/search', { query, sourceHorseId }).catch(() => {})
    }, 250)
  }

  function loadInitialOptions(sourceHorseId) {
    return store.dispatch('horseMerge/search', { query: '', sourceHorseId })
  }

  function loadPreview(sourceHorseId, targetHorseId) {
    return store.dispatch('horseMerge/preview', {
      source_horse_id: Number(sourceHorseId),
      target_horse_id: Number(targetHorseId)
    })
  }

  function merge(sourceHorseId, targetHorseId, previewToken, reason) {
    return store.dispatch('horseMerge/merge', {
      source_horse_id: Number(sourceHorseId),
      target_horse_id: Number(targetHorseId),
      preview_token: previewToken,
      reason
    })
  }

  function clearPreview() {
    return store.dispatch('horseMerge/clearPreview')
  }

  function reset() {
    clearTimeout(searchTimer)
    return store.dispatch('horseMerge/reset')
  }

  return {
    searchResults,
    searchLoading,
    preview,
    previewLoading,
    merging,
    search,
    loadInitialOptions,
    loadPreview,
    merge,
    clearPreview,
    reset
  }
}



// WEBPACK FOOTER //
// ./src/composables/horses/useHorseMerge.js